import debounce from 'awesome-debounce-promise';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function useOrdersSearch() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const clearSearch = () => {
    setSearch('');
  };

  const handleSearch = debounce((value: string) => {
    const path = value ? `/orders?search=${encodeURIComponent(value)}` : '/orders';
    navigate(path);
    setSearch(value);
  }, 500);

  return {
    search,
    handleSearch,
    clearSearch,
  };
}
